'use client';
import React, { useState } from 'react';
import RewardsHero from './RewardsHero';
import LevelProgress from './LevelProgress';
import AvailableRewards from './AvailableRewards';
import ActiveChallenges from './ActiveChallenges';
import StarsHistory from './StarsHistory';
import StarsChart from './StarsChart';

export default function RewardsClient() {
  const [activeTab, setActiveTab] = useState<'ödüller' | 'geçmiş'>('ödüller');

  return (
    <div>
      <RewardsHero stars={340} />
      <LevelProgress stars={340} />

      {/* Tabs */}
      <div className="px-4 py-3 flex gap-2 border-b border-border bg-card">
        <button
          onClick={() => setActiveTab('ödüller')}
          className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${
            activeTab === 'ödüller' ? 'bg-primary text-white' : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Ödüller
        </button>
        <button
          onClick={() => setActiveTab('geçmiş')}
          className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${
            activeTab === 'geçmiş' ? 'bg-primary text-white' : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          Geçmiş
        </button>
      </div>

      {activeTab === 'ödüller' ? (
        <>
          <AvailableRewards stars={340} />
          <ActiveChallenges />
        </>
      ) : (
        <>
          <StarsChart />
          <StarsHistory />
        </>
      )}
    </div>
  );
}